export const CONTACT_EMAIL = 'nutrinaturalonline@gmail.com'

export interface LegalDocument {
  title: string
  updated: string
  blocks: { heading: string; paragraphs: string[] }[]
}

export const privacyPolicy: LegalDocument = {
  title: 'Política de Privacidad',
  updated: 'Última actualización: enero 2026',
  blocks: [
    {
      heading: '1. Información que recopilamos',
      paragraphs: [
        'Recopilamos únicamente la información necesaria para procesar tu compra y entregarte el producto digital: nombre, correo electrónico y los datos de facturación que proporcionas en la plataforma de pago.',
        'No almacenamos datos de tarjetas de crédito ni información financiera. Todo el procesamiento de pagos se realiza en la pasarela de pago externa, bajo sus propios estándares de seguridad.',
      ],
    },
    {
      heading: '2. Uso de la información',
      paragraphs: [
        'Usamos tus datos para entregarte el acceso al producto, enviarte información relacionada con tu compra y, si lo autorizas, comunicaciones educativas sobre el método. Puedes darte de baja en cualquier momento desde el enlace incluido en cada correo.',
        'No vendemos, alquilamos ni compartimos tus datos personales con terceros para fines publicitarios.',
      ],
    },
    {
      heading: '3. Cookies y tecnologías de medición',
      paragraphs: [
        'Este sitio utiliza cookies propias y de terceros, incluyendo herramientas de medición y publicidad como Meta (Facebook) Pixel y Google Analytics, para entender el rendimiento de nuestras campañas y mostrar anuncios relevantes.',
        'Puedes desactivar las cookies desde la configuración de tu navegador. Hacerlo no impide la compra ni el acceso al producto.',
      ],
    },
    {
      heading: '4. Tus derechos',
      paragraphs: [
        'Puedes solicitar en cualquier momento el acceso, la rectificación o la eliminación de tus datos personales, así como retirar tu consentimiento, escribiendo a nuestro correo de soporte.',
      ],
    },
    {
      heading: '5. Contacto',
      paragraphs: [
        'Para cualquier solicitud relacionada con tus datos personales, escríbenos a nutrinaturalonline@gmail.com. Respondemos a las solicitudes en un plazo razonable.',
      ],
    },
  ],
}

export const termsAndConditions: LegalDocument = {
  title: 'Términos y Condiciones',
  updated: 'Última actualización: enero 2026',
  blocks: [
    {
      heading: '1. Naturaleza del producto',
      paragraphs: [
        'Método Glucosa Estable es un producto digital de carácter educativo e informativo. La compra otorga una licencia personal, no transferible, para acceder a los materiales. Queda prohibida su reventa, reproducción o distribución total o parcial.',
      ],
    },
    {
      heading: '2. Pago y acceso',
      paragraphs: [
        'El pago es único: no existen suscripciones, renovaciones automáticas ni cargos recurrentes. El acceso se entrega de forma digital inmediatamente después de confirmarse el pago.',
        'Los precios se muestran en dólares estadounidenses. La pasarela de pago puede ofrecer métodos de pago locales y realizar la conversión automática a la moneda de tu país; el monto final convertido se muestra antes de confirmar la compra.',
      ],
    },
    {
      heading: '3. Garantía y reembolsos',
      paragraphs: [
        'Ofrecemos una garantía de 60 días desde la fecha de compra. Si aplicas el protocolo y no observas los cambios descritos, puedes solicitar la devolución completa del importe pagado escribiendo a nuestro correo de soporte dentro de ese plazo. Las solicitudes se procesan en un plazo aproximado de 48 horas.',
        'El cobro y la devolución son gestionados por la plataforma de pago (Hotmart), conforme a sus propios términos y procedimientos de reembolso.',
      ],
    },
    {
      heading: '4. Descargo de responsabilidad de salud',
      paragraphs: [
        'El contenido no constituye consejo médico, diagnóstico ni tratamiento, y no sustituye la consulta con un profesional de la salud. Si estás embarazada, en lactancia, tomas medicación, tienes diabetes u otra condición metabólica, consulta a tu médico antes de aplicar cualquier cambio en tu alimentación.',
      ],
    },
    {
      heading: '5. Resultados',
      paragraphs: [
        'Los testimonios y ejemplos mostrados reflejan experiencias individuales y no representan una promesa ni una garantía de resultados. Los resultados dependen de factores personales, incluida la aplicación constante del protocolo.',
      ],
    },
    {
      heading: '6. Propiedad intelectual y modificaciones',
      paragraphs: [
        'Todos los contenidos, textos, gráficos y materiales del sitio y del producto están protegidos por derechos de autor. Podemos actualizar estos términos y el contenido del producto; la versión vigente es la publicada en esta página.',
      ],
    },
  ],
}
